// extracted by mini-css-extract-plugin
export var childrenContainer = "_af-0";
export var virtualScrollArea = "_af-1";